module.exports = __webpack_public_path__ + "static/img/post_4.76666c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/posts/post_4.png
// module id = F1ZJ
// module chunks = 0